define(function(require) {

    var _ = require('underscore');
    var $ = require('j');
    var GamesInfoView = require('portlets/games-info/gamesinfo.view');
    var favoritesStore = require('stores/favorites/favorites.store.instance');
    var gameTracker = require('modules/trackers/game.tracker.instance');
    var device = require('util/device.util');
    var core = require('core');
    var storage = require('util/storage.util');
    var user = require('user');
    var config = require('config');
    var url = require('util/url.util');
    var historyUtil = require('util/history.util');
    var utils = require('utils');
    var Swipe = require('class/swipe.class');
    var mathAlgorithms = require('util/math.util').algorithms;
    var layoutHelper = require('portlets/games-info/gamesinfo.game.layout.helper');
    var Form = require('class/form.class');

    require('widgets/totalcasino-theme/dropdown.widget');
    require('widgets/totalcasino-theme/paging.widget');
    require('widgets/totalcasino-theme/scrollSpy.widget');
    require('widgets/totalcasino-theme/custompaging.widget');

    return GamesInfoView.extend({

        events: _.extend(GamesInfoView.prototype.events, {
            'tap .fn-back-button': 'navigateBack'
        }),

        initialize: function() {
            var getGamesCustomCssConfig = this.getGamesCustomConfig();
            var sliderConfig = config.get('gamesSliderConfig') || {};

            this._customLayoutCssValues = getGamesCustomCssConfig.tilesCustomCssValues;

            this.model.set('useCustomPaging',
                Boolean(this._isCustomPagingNeeded() && sliderConfig.useCustomPagination));
            this.model.set('useLazyLoading', Boolean(sliderConfig.useLazyLoading));

            this.listenTo(core, {
                'popups:showGameInfoPopup': this.showGameInfo,
                'gameFavoritesChange:success': this.onFavoritesUpdate,
                'page:rendered': this.afterRender,
                'auth:logout': this.renderGames,
                'game:close': this.onGameClose,
                'navigate:start': this.handleCategoryChangeByParam
            });

            GamesInfoView.prototype.initialize.apply(this, arguments);
        },

        onGameClose: function() {
        },

        handleCategoryChangeByParam: function(path) {
            var param = url.getURLParams(path).cat;
            if (param) {
                this._changeCategory(param);
            }
        },

        subscribe: function() {
            var isDesktop = device.formFactor === 'desktop';
            var isCustomLayout;

            GamesInfoView.prototype.subscribe.call(this, arguments);

            if (this.model.get('useLazyLoading')) {
                this.lazyId = utils.guid();
                $(window).on('scroll.gameInfo_' + this.lazyId, _.throttle(this._updateLazyImages.bind(this), 200));
            }

            this._updateLayoutMap();

            isCustomLayout = this.getIsCustomLayout();

            if (!isDesktop && isCustomLayout) {
                $(window).on('orientationchange', _.debounce(this.handleOrientationChange.bind(this), 100));
            }
        },

        handleOrientationChange: function() {
            this.calculateBreakpoint();

            this._updateLayoutMap();
            this.renderGames();

            this.model.get('useLazyLoading') && this._updateLazyImages();
        },

        onFavoritesUpdate: function(gameCode) {
            this.updateGameInfo(gameCode);
            this._updateLazyImages();
        },

        navigateBack: function() {
            var backURL = url.getLocationParameterByName('back_url');

            var isBackUrlEmpty = _.isEmpty(backURL);
            if (!isBackUrlEmpty) {
                if (device.isIphoneChromeBrowserProblematic) {
                    historyUtil.pushState(null, null, url.pathname);
                }
                core.navigate(backURL);
            } else {
                window.history.back();
            }
        },

        _renderTitle: function() {
            var shouldRenderLink = this.$('.bingo_gamesportlet-with-link').length > 0;
            if (shouldRenderLink) {
                this.renderBingoGamesPortletTitle();
            }
        },

        renderSearch: function() {
            GamesInfoView.prototype.renderSearch.apply(this, arguments);
            this.renderGameStudioDropdown();
        },

        renderBingoGamesPortletTitle: function() {
            var bingoLink = this.$('.bingo_slots').length > 0 ? config.get('bingoSlotsLink') : config.get(
                'bingoExclusiveLink');
            var isDesktop = device.formFactor === 'desktop';
            this.$('.fn-portlet-title-region').html(this.tmpl('gamesinfo.bingo.portlet.title', {
                title: this.options.title,
                link: bingoLink,
                isDesktop: isDesktop
            }));
        },

        updateGameInfo: function(gameCode) {
            if (this.$gamesInfoContainer && this.$gamesInfoContainer.parent().hasClass('open')) {
                this.showGameInfo(gameCode);
            }
        },

        toggleGameFavorites: function(e) {
            e.stopImmediatePropagation();

            var $toggleFavoriteBtn = $(e.currentTarget);
            var gameCode = $toggleFavoriteBtn.data('gameCode');
            var favoriteId = this.model ? this.model.games.get(gameCode).id : gameCode;
            var feedName = this.options ? this.options.categoriesFeedName : storage.session.getItem(
                'lastCategoriesFeedName');

            if ($toggleFavoriteBtn.hasClass('disabled')) {
                return;
            }

            this.trackers = this.trackers || [gameTracker];

            this.track(
                'gameFavoritesChange',
                {
                    feedName: feedName,
                    gameCode: gameCode,
                    method: !favoritesStore.hasItem(favoriteId) ? 'Add' : 'Remove'
                },
                this
            );

            this.toggleFavorites({
                favoriteID: favoriteId,
                type: 'game'
            }, $toggleFavoriteBtn);
        },

        _successAddToFavorites: function(model, $favoritesBtn) {
            GamesInfoView.prototype._successAddToFavorites.apply(this, arguments);
            core.trigger('gameFavoritesChange:success', $favoritesBtn[0].dataset.gameCode);
        },

        _successRemoveFromFavorites: function($favoritesBtn) {
            $favoritesBtn && $favoritesBtn.removeClass('active');
            this.showInfo({
                content: this.translate('playtech.mobile.system.message.successRemoveFromFavorites'),
                variant: this.toastVariants.INFO
            });
            core.trigger('gameFavoritesChange:success', $favoritesBtn[0].dataset.gameCode);
        },

        changeViewMode: function() {
            GamesInfoView.prototype.changeViewMode.apply(this, arguments);
            core.trigger('gamesViewMode:changed');
        },

        getGamesCustomConfig: function() {
            var customCssClassName = this.options && this.options.customCSSClassName;
            var re = /games-portlet__+[a-z]*/i;
            var gamesPortletType = customCssClassName && customCssClassName.match(re);
            gamesPortletType = gamesPortletType ? gamesPortletType[0] : '';
            var templateName, tilesCustomCssValues;
            var gamesCustomConfig = {};
            var isDesktop = device.formFactor === 'desktop';

            switch (gamesPortletType) {
                case 'games-portlet__casino':
                    templateName = 'common.gameItem.casino';

                    if (isDesktop) {
                        tilesCustomCssValues = 'casino';
                    } else {
                        tilesCustomCssValues = 'casinoMobile';
                    }
                    break;
                default:
                    templateName = 'common.gameItem';
                    tilesCustomCssValues = 'default';
                    break;
            }

            gamesCustomConfig.templateName = templateName;
            gamesCustomConfig.tilesCustomCssValues = config.get('tilesCustomCssValues.' + tilesCustomCssValues);

            return gamesCustomConfig;
        },

        renderGames: function() {
            var activeCategory, gamesHtml, itemTemplate, limitPerSlide, previousGamesHeight, template;
            var gamesTemplateName = this.getGamesCustomConfig().templateName;

            this.model.set('gamesTemplateName', gamesTemplateName);

            this.$games = this.$('.fn-games');

            this.dynamicGameImages.disable();

            var $swipeElements = this.$('.fn-scroll-row-list');

            _.each($swipeElements, this.setSwipeX.bind(this));

            if (!this.model.categories.length) {
                return this;
            }

            var activeCategoryModel = this.model.categories.getActive();

            if (this.options.sortBy && !activeCategoryModel.get('enableDynamicCategory')) {
                activeCategoryModel.sortGames(this.model.get('sortField'));
            }

            activeCategory = activeCategoryModel.toJSON();
            activeCategory.games = this.model.getCategoryGamesOrFilterThemByCMS(activeCategory);

            template = 'gamesinfo.gameitems.' + this.options.viewMode.toLowerCase();
            itemTemplate = this._getItemTemplate(template);
            limitPerSlide = this._getLimitPerSlide();

            var templateAttrs = {
                category: activeCategory,
                games: this.model.games,
                navigationType: this.options.navigationType,
                limitPerSlide: limitPerSlide,
                showJackpots: this.model.get('showJackpots'),
                isDesktop: device.formFactor === 'desktop',
                itemView: this.options.itemView,
                isError: this.model.get('isError') || false,
                isResponsive: this.options.responsiveGrid,
                col: this.options.gamesNumberOfColumns,
                row: this.options.gamesNumberOfRows,
                isFavoritesAllowed: user.isLoggedIn() && this.options.useFavoritesEnabled,
                isDisabledDemoMode: user.isLoggedIn() && this.options.disableDemoWhenLoggedIn,
                itemTemplate: itemTemplate,
                model: this.model.toJSON(),
                view: this,
                articles: Playtech.Variables.gamesArticles,
                layoutMap: this.layoutMap
            };

            if (activeCategory.isLoading) {
                previousGamesHeight = this.$games.css('height');
                if (activeCategory.name === 'favorites') {
                    previousGamesHeight = undefined;
                }
            }

            gamesHtml = this.tmpl(template, templateAttrs);

            // prevent scrolling top on dynamic category load
            this.$games.css('height', activeCategory.isLoading ? previousGamesHeight : '');

            this._removeGamesJackpots();
            this.removeScalingWidget();
            this.removePaging();

            this.$games.html(gamesHtml);

            this.$games
                .off('.paging')
                .on('paging:pageChanged.paging', this._handlePageChangeStart.bind(this))
                .on('paging:endAnimation.paging', this._handlePageChangeEnd.bind(this));

            activeCategory.games && this.renderPaging(activeCategory.games.length, limitPerSlide);

            this.addScalingWidget();
            this.fixLastRowItemsDisplay();
            this._addGamesJackpots();

            if (this.portletHasMounted) {
                this.resizeCustomLayout();
                this.fixPageHeight();
                this.dynamicGameImages.enable();
            }

            core.trigger('games:rendered');

            return this;
        },

        setSwipeX: function(el) {
            var rowsSwipe = new Swipe($(el), {
                detectingStrategy: function(swipe, touch) {
                    var isDetecting = Swipe.detectingStrategies.x.call(swipe, swipe, touch);
                    var isSwipe = true;

                    return isDetecting && isSwipe;
                }
            });

            var expected = 0;
            var easing;
            var lastChange;
            var force;
            var time;

            rowsSwipe.on({
                move: function(item) {
                    force = Math.abs(lastChange - item.delta.x);
                    force = Math.round(force * force / 100);
                    item.translate(item.start.x - item.delta.x, 0);
                    lastChange = item.delta.x;
                },

                end: function(item) {
                    easing = mathAlgorithms.easeInQuad;
                    time = 10;
                    var rowWidth = item.el.getBoundingClientRect().width;
                    var maxRightPosition = (document.body.clientWidth - rowWidth) / this.scaleFactor;

                    if (item.position.x > 0) {
                        expected = 0;
                    } else {
                        time = force * 10;
                        expected = item.position.x + force * 50 * (item.delta.x > 0 ? -1 : 1);
                        easing = mathAlgorithms.easeOutQuint;

                        if (expected > 0) {
                            expected = 0;
                            time = 10;
                        } else if (expected < maxRightPosition) {
                            expected = maxRightPosition;
                            time = 10;
                        }
                    }
                    item.animateTo(expected, 0, time, easing);
                }.bind(this)

            }, this);
        },

        _isCustomPagingNeeded: function() {
            var isPagingEnabled = this.options.viewMode === 'ITEM' && this.options.navigationType === 'SLIDER';
            var isCustomPagingNeeded = isPagingEnabled && this.options.itemView === 'LIGHT';

            return isPagingEnabled && isCustomPagingNeeded;
        },

        /*
         * @layoutOption {boolean} useLayoutsDependentOnOrientation:
         *   If flag is enabled,
         *   then use a option "navigationPosition" to select the layout depending on screen orientation:
         *   - portrait orientation - use layout from "top" (navigationPosition TOP for games categories menu)
         *   - landscape orientation - use layout for "left" (navigationPosition LEFT for games categories menu)
         * */
        _updateLayoutMap: function() {
            var categories = this.model.categories;

            if (!categories || !categories.length) {
                return;
            }

            var activeCategory = this.model.categories.getActive();
            var categoryLayout = this.getCategoryLayout(activeCategory);

            this.layoutMap = layoutHelper.getMap(categoryLayout, this.options);

            if (this.layoutMap) {

                var customLayoutName = categoryLayout;
                var layouts = config.get('gamesTilesLayoutsCustomConfig');

                var customLayout = _.findWhere(layouts, { name: customLayoutName }) || {};
                var scrollingRowOptions = _.pick(customLayout, 'useScrollingRow', 'showItemsInScrollingRow');

                var navigationPosition = this.options.navigationPosition;
                var useLayoutsDependentOnOrientation = customLayout.useLayoutsDependentOnOrientation;

                if (useLayoutsDependentOnOrientation) {
                    this.options.navigationPosition = this.getLayoutByDeviceOrientation();
                }

                _.extend(this.layoutMap, this._customLayoutCssValues);

                this.options.navigationPosition = navigationPosition;

                var options = _.extend({},
                    scrollingRowOptions,
                    {
                        useLayoutsDependentOnOrientation: useLayoutsDependentOnOrientation
                    }
                );

                options = _.defaults(options, {
                    useScrollingRow: false,
                    showItemsInScrollingRow: 3,
                    useLayoutsDependentOnOrientation: false
                });

                _.extend(this.layoutMap, options);
            }
        },

        getCategoryLayout: function(categoryModel) {
            var customLayout = categoryModel.get('customLayout');
            var categoryName = categoryModel.get('name');
            var layout;

            if (window.TotalcasinoConfig && window.TotalcasinoConfig.Providers &&
                window.TotalcasinoConfig.Providers[categoryName] &&
                window.TotalcasinoConfig.Providers[categoryName].layouts &&
                window.TotalcasinoConfig.Providers[categoryName].layouts[device.formFactor]) {
                layout = window.TotalcasinoConfig.Providers[categoryName].layouts[device.formFactor];
            }

            return layout || customLayout;
        },

        getLayoutByDeviceOrientation: function() {
            var mapDeviceOrientationToNavigationPosition = {
                portrait: 'TOP',
                landscape: 'LEFT'
            };

            return mapDeviceOrientationToNavigationPosition[device.orientation];
        },

        resizeCustomLayout: function() {
            if (!this.getIsCustomLayout() || this.options.viewMode !== 'ITEM') {
                return;
            }

            var $items = this.$('.fn-style-extended');
            if (!$items.length) {
                return;
            }

            var scrollRowRatio = 1;

            if (this.layoutMap.useScrollingRow) {
                var layout = this.options.navigationPosition.toLowerCase();

                if (this.layoutMap.useLayoutsDependentOnOrientation) {
                    layout = this.getLayoutByDeviceOrientation();
                }

                var showItemsInScrollingRow = this.layoutMap.showItemsInScrollingRow;

                showItemsInScrollingRow = _.isObject(showItemsInScrollingRow)
                    ? showItemsInScrollingRow[layout.toLowerCase()]
                    : showItemsInScrollingRow;

                scrollRowRatio = this.layoutMap.gridWidth / showItemsInScrollingRow;
            }

            var itemSizeEm = this._customLayoutCssValues.cellWidth + this._customLayoutCssValues.cellMarginL
                + this._customLayoutCssValues.cellMarginR;
            var currentLayoutFirstItemSizeEm = this._customLayoutCssValues.cellWidth
                + (this.layoutMap.list[0].w - 1) * itemSizeEm;
            var currentLayoutFirstItemSizePx = parseFloat(getComputedStyle($items[0]).width);
            var emSize = currentLayoutFirstItemSizePx / currentLayoutFirstItemSizeEm;

            var listSizeEm = this.layoutMap.gridWidth * itemSizeEm
                + this._customLayoutCssValues.containerPaddingL + this._customLayoutCssValues.containerPaddingR;
            var listSizePx = listSizeEm * emSize;

            var $container = this.$('.fn-game-items');
            var containerSizePx = parseFloat(getComputedStyle($container[0]).width);
            var scaleFactor = scrollRowRatio * containerSizePx / listSizePx;

            this.scaleFactor = scaleFactor;

            $container.css({
                'transform': 'scale(' + scaleFactor + ')',
                '-webkit-transform': 'scale(' + scaleFactor + ')'
            });

            var listBottomPx;
            var $resizeContainer = $container.find('.fn-resize-container');

            if (this.layoutMap.useScrollingRow) {
                $resizeContainer.css('height', 'auto');
                listBottomPx = $resizeContainer[0].clientHeight;
            } else {
                listBottomPx = $items.reduce(function(memo, tile) {
                    var cs = getComputedStyle(tile);
                    var bottom = parseFloat(cs.top) + parseFloat(cs.height);
                    if (bottom > memo) {
                        memo = bottom;
                    }

                    return memo;
                }, 0);
            }

            var marginBottomEm = this._customLayoutCssValues.cellMarginB;
            var calculatedHeightPx = listBottomPx * scaleFactor;
            var calculatedMarginEm = marginBottomEm * scaleFactor + 0.5; // TODO: "0.5" - calculating ratio
            $container.css('height', 'calc(' + calculatedHeightPx + 'px + ' + calculatedMarginEm + 'em)');

            // we could simply resize `.fn-resize-container` only, but Chrome has a bug - blurring all container when
            // adding box shadow on item (which we do on mouse hover) or some other unrelated styles
            $resizeContainer.css('height', 'calc(' + listBottomPx + 'px + ' + marginBottomEm + 'em)');
            $resizeContainer.css('width', 'calc(100% / ' + scaleFactor + ')');
        },

        renderPaging: function(gameCount, limitPerPage) {
            var pageCount = Math.ceil(gameCount / limitPerPage);
            var isPagingEnabled = this.options.viewMode === 'ITEM' && this.options.navigationType === 'SLIDER';
            var isCustomPagingNeeded = this._isCustomPagingNeeded();

            if (!isPagingEnabled || pageCount <= 1) {
                return;
            }

            if (isCustomPagingNeeded && this.model.get('useCustomPaging')) {
                this.$el.addClass('customPagination');

                this.attachWidget(this.$games.custompaging({
                    elementSelector: '.gamesinfo__item',
                    containerSelector: '.gamesinfo__items',
                    changeCallBack: this.model.get('useLazyLoading') ? this._updateLazyImages.bind(this) : null
                }));
            } else {
                this.attachWidget(this.$games.paging({
                    type: 'bullet',
                    activePage: 0,
                    lengthOfPages: pageCount,
                    arrows: true,
                    infinity: false
                }));
            }

            this.options.hasPaging = true;

            if (this.portletHasMounted) {
                this.fixLastPageHeight();
            } else {
                this.once('portlet:mounted', this.fixLastPageHeight.bind(this));
            }
        },

        _updateLazyImages: function() {
            this.$('.gamesinfo__item').forEach(function(gameEl) {
                var $gameImage = $(gameEl).find('.gamesinfo__img');
                var shouldLoadImage = $gameImage &&
                    !$gameImage.hasClass('fn-loaded-image') &&
                    $gameImage.attr('data-style') &&
                    !$gameImage.attr('style') &&
                    $gameImage.isInViewportByPercentage(0.1);

                if (shouldLoadImage) {
                    $gameImage.attr('style', $gameImage.attr('data-style'));
                    $gameImage.addClass('fn-loaded-image');
                }
            });
        },

        removePaging: function() {
            this.options.hasPaging = false;

            if (this.model.get('useCustomPaging')) {
                this.detachWidget(this.$games, 'custompaging');
            } else {
                this.detachWidget(this.$games, 'paging');
            }
        },

        renderControls: function() {
            var $controls = this.$('.fn-controls');
            var newGridPath = config.get('dynamicTags.DTAG_NEW_GAMES_GRID_PATH');
            var controlsConfig = {
                viewModes: this._getViewModesConfig(),
                search: this._getSearchConfig(),
                sorting: this._getSortingConfig(),
                newGridPath
            };

            $controls.html(this.tmpl('gamesinfo.controls', controlsConfig));

            this.renderSearch();

            Form.prototype.wrapFormControls($controls);
        },

        afterRender: function() {
            $('.fn-games-menu').length && this.setActiveGamesMenu();

            var customCssClassName = this.options && this.options.customCSSClassName;
            var isStickyGamesCategoriesMenu = customCssClassName && customCssClassName.indexOf('sticky-menu') !== -1;
            var customCSSClassName = this.options.customCSSClassName;
            var isCasinoGamesPortlet = customCSSClassName && customCSSClassName.indexOf('games-portlet__casino') > -1;
            var isGameRowsAnimationShown = storage.local.getItem('isGameRowsAnimationShown');
            var isDesktop = device.formFactor === 'desktop';
            var shouldAnimateGameRows = isCasinoGamesPortlet && !isGameRowsAnimationShown && !isDesktop;

            if (isStickyGamesCategoriesMenu && this.options.navigationPosition === 'TOP') {
                this.initializeStickyGamesCategoriesMenu();
            }

            this.model.get('useLazyLoading') && this._updateLazyImages();

            if (shouldAnimateGameRows) {
                this.animateGameRows();
            }
        },

        animateGameRows: function() {
            var $scrollRows = this.$('.gamesinfo__scroll-row');

            if (!$scrollRows.length) {
                return;
            }

            var scrollClassName = 'games-row-animation';
            var extendedWidthClass = 'games-row-extended-width';
            var transitionEvent = this.getTransitionEvent();
            var firstRowEl = $scrollRows[0];
            var secondRowEl = $scrollRows[1];

            $scrollRows.addClass(extendedWidthClass);

            firstRowEl.addEventListener(transitionEvent, animateFirstRow);

            function animateFirstRow() {
                if (firstRowEl.classList.contains(scrollClassName)) {
                    firstRowEl.classList.remove(scrollClassName);
                } else {
                    firstRowEl.removeEventListener(transitionEvent, animateFirstRow);
                    secondRowEl.addEventListener(transitionEvent, animateSecondRow);
                    secondRowEl.classList.add(scrollClassName);
                }
            }

            function animateSecondRow() {
                if (secondRowEl.classList.contains(scrollClassName)) {
                    secondRowEl.classList.remove(scrollClassName);
                } else {
                    secondRowEl.removeEventListener(transitionEvent, animateSecondRow);
                    $scrollRows.removeClass(extendedWidthClass);
                    storage.local.setItem('isGameRowsAnimationShown', true);
                }
            }

            firstRowEl.classList.add(scrollClassName);
        },

        getTransitionEvent: function() {
            var el = document.createElement('fakeelement');
            var transitions = {
                'transition': 'transitionend',
                'OTransition': 'oTransitionEnd',
                'MozTransition': 'transitionend',
                'WebkitTransition': 'webkitTransitionEnd'
            };

            for (var transition in transitions) {
                // eslint-disable-next-line no-prototype-builtins
                if (transitions.hasOwnProperty(transition)) {
                    if (el.style[transition] !== undefined) {
                        return transitions[transition];
                    }
                }
            }
        },

        initializeStickyGamesCategoriesMenu: function() {
            var $gamesMenuWC = $('.games-menu-wrapper');
            var $stickyMenuWrapper = $($('.fn-game-categories-wrapper')[0]);
            var $stickyMenu = $stickyMenuWrapper.find('.fn-game-categories-menu');

            if ($gamesMenuWC.length) {
                $stickyMenuWrapper = $gamesMenuWC;
                $stickyMenu = $('.fn-games-menu');
            }

            this.attachWidget(this.$el.scrollSpy({
                direction: 'top',
                fixedElement: $stickyMenu,
                elementWrapper: $stickyMenuWrapper,
                stickToElement: $('.fn-navigation-container'),
                fixToElement: $('.sticky-menu__bottom'),
                breakpoint: this.calculateBreakpoint(),
                checkFunc: this.calculateBreakpoint
            }));
        },

        calculateBreakpoint: function() {
            var $gamesMenuWC = $('.games-menu-wrapper');
            var $stickyMenuWrapper = $gamesMenuWC.length ? $gamesMenuWC : $('.fn-game-categories-wrapper');

            var $categoryMenu = $('.fn-game-categories-menu');
            var $stickyBottom = $('.sticky-menu__bottom');
            var $header = $('.fn-header-container');

            var headerHeight = $header.getHeight();
            var gamesMenuHeight = $gamesMenuWC.length ? $gamesMenuWC.getHeight() : $categoryMenu.getHeight();
            var minHeight = headerHeight + gamesMenuHeight;
            var headerBottomPosition = $header[0] && $header[0].getBoundingClientRect().bottom;
            var portletBottomPosition = $stickyBottom.offset().top + $stickyBottom.getHeight() - $header.getHeight();
            var scrolledToBottomOfPortlet = window.pageYOffset - 1 > portletBottomPosition - headerBottomPosition
                - gamesMenuHeight;

            var breakpoint = $stickyMenuWrapper[0] ? $stickyMenuWrapper[0].getBoundingClientRect().top : 0;

            var isSmallScreen = device.realScreenDimensions.height < minHeight;
            $('body').toggleClass('body-small-screen', isSmallScreen);

            if (scrolledToBottomOfPortlet) {
                breakpoint = window.innerHeight + 1;
            }

            return breakpoint;
        },

        setActiveGamesMenu: function() {
            var currentUrl = url.getCleanUrl(url.pathname);
            $('.fn-games-menu a').parent().removeClass('active');
            $('.fn-games-menu a[href="' + currentUrl + '"]').parent().addClass('active');
        },

        _onCategoryClick: function() {
            GamesInfoView.prototype._onCategoryClick.apply(this, arguments);
            window.scrollTo(0, 0);
        },

        checkSwipeCategory: function(fitToScreen) {
            var navigationViewportEl = this.$('.fn-navigation')[0];
            var navigationCategoriesList = this.categorySwipe.el;
            var translateXValue = 0;
            var navigationCategoriesListCategories = navigationCategoriesList.childNodes;
            var navigationActiveCategory = this.categorySwipe.el.querySelector('.fn-category.active');
            var navigationActiveCategoryIndex = [].indexOf.call(navigationCategoriesListCategories,
                navigationActiveCategory);
            var navigationActiveCategoryPlusPreviousSiblingsWidth = 0;
            var i;

            if (navigationCategoriesList.clientWidth > navigationViewportEl.clientWidth) {
                if (fitToScreen) {
                    for (i = 0; i <= navigationActiveCategoryIndex; i++) {
                        navigationActiveCategoryPlusPreviousSiblingsWidth +=
                            navigationCategoriesListCategories[i].clientWidth;
                    }
                    if (navigationActiveCategoryPlusPreviousSiblingsWidth > navigationViewportEl.clientWidth) {
                        translateXValue = navigationViewportEl.clientWidth
                            - navigationActiveCategoryPlusPreviousSiblingsWidth;
                    }
                    this.categorySwipe.translate(translateXValue, 0);
                }
                return true;
            }

            this.categorySwipe.translate(translateXValue, 0);

            return false;
        },

        renderGameStudioDropdown: function() {
            var gameStudioConfig = this.getGameStudioWidgetOptions();
            var $dropdown = this.$('.dropdown');

            if (gameStudioConfig.source.data.length === 0) {
                $dropdown.parent().addClass('hidden');
                console.log('this.$el', this.$el);
                this.$el.find('.gameitems-block').addClass('gameitems-block--no-providers');
                return;
            }

            this.detachWidget($dropdown, 'dropdown');
            this.attachWidget($dropdown.dropdown(gameStudioConfig));

            $dropdown
                .off('.dropdown')
                .on('dropdown:changed.dropdown', function(event) {
                    this._changeCategory(event.category);
                }.bind(this));
        },

        getGameStudioWidgetOptions: function() {
            var options = {
                labelField: 'name',
                source: {
                    data: [],
                    fields: ['name']
                }
            };
            var providerCategories = this.model.categories.toJSON();
            var activeCategory = this.model.categories.getActive().toJSON();

            providerCategories = providerCategories.filter(category => category.isProvider);

            if (window.TotalcasinoConfig && window.TotalcasinoConfig.Providers) {
                var providers = window.TotalcasinoConfig.Providers;
                providerCategories = providerCategories.filter(category => {
                    return _.isUndefined(providers[category.name]) ||
                        _.isUndefined(providers[category.name].show)
                        || providers[category.name].show;
                });
            }

            if (providerCategories.find(cat => activeCategory.name === cat.name)) {
                options.activeItem = activeCategory;
            }

            options.source.data = providerCategories;
            return options;
        },

        close: function() {
            if (this.model.get('useLazyLoading')) {
                $(window).off('scroll.gameInfo_' + this.lazyId);
            }
            // Remove from URL cat
            var cleanedParams = _.omit(url.getURLParams(), 'cat');
            var params = _.isEmpty(cleanedParams) ? '' : '?' + url.serialize(cleanedParams);

            historyUtil.replaceState(null, null, url.pathname + params);

            GamesInfoView.prototype.close.call(this);
        },

        /**
         * Next 2 methods use in the HTML
         */
        getGameImageUrl: function(it) {
            var imageUrls = !it.isDesktop && it.game.get('mobileImageURLs') || it.game.get('imageURLs');
            var imgTileSize = it.isCustomLayout ? it.imgTileSize.toLowerCase() : 'c1x1';
            var imageUrl = imageUrls && imageUrls[imgTileSize];

            return imageUrl;
        },

        getGameResizeGroup: function(it) {
            var imgTileSize = it.isCustomLayout ? it.imgTileSize.toLowerCase() : 'c1x1';
            var resizeGroup = it.isCustomLayout ? '1' + imgTileSize : '1';

            return resizeGroup;
        }
    });
});
